export default __webpack_public_path__ + "static/media/electrical-energy.7fb3712d.png";